import { forwardRef } from "react";
import PropTypes from "prop-types";

const InputDate = forwardRef(
  ({ label, value, onChange, placeholder, error, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label className="text-base md:text-sm font-medium">{label}</label>
        )}
        <input
          type="date"
          ref={ref}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full text-base md:text-sm px-4 py-2 input-base transition focus:outline-none ${
            error
              ? "border-red-500 focus:ring-red-500"
              : "focus:ring-blue-500 focus:border-blue-500"
          }`}
          {...props}
        />
        {error && <p className="text-red-500! text-xs mt-1">{error}</p>}
      </div>
    );
  }
);

InputDate.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
};

InputDate.displayName = "InputDate";

export default InputDate;
